import type { SceneContext } from '../_shared/types'
import type { ChartRaceData } from './types'
import { chartRaceInterpolate } from './tick'

const ROW_H = 28 // 预览行高（bar 18 + gap），与 .pv-bar-track height 对齐

// 柱状图竞速：value 帧间插值（连续）+ 按当前 value 实时排序。
// 播放时 rAF 60fps 每帧重算 top/width，不用 CSS transition（transition + 高频更新会冲突黑屏）。
export default function ChartRace({ data, time, duration }: SceneContext) {
  const d = data as unknown as ChartRaceData
  const { year, items } = chartRaceInterpolate(data, time, duration)
  if (items.length === 0) return null
  const maxVal = items[0]?.value || 3.5
  return (
    <div className="pv-chart-race" style={{ background: (data as any).bgColor }}>
      {d.title && <div className="pv-chart-title">{d.title}</div>}
      <div className="pv-chart-year">{year}</div>
      <div className="pv-chart-bars" style={{ position: 'relative', width: '100%', height: items.length * ROW_H }}>
        {items.map((item, rank) => (
          <div
            className="pv-bar-row"
            key={item.label}
            style={{ position: 'absolute', top: rank * ROW_H, left: 0, right: 0 }}
          >
            <span className="pv-bar-label">{item.label}</span>
            <div className="pv-bar-track">
              <div
                className="pv-bar-fill"
                style={{
                  width: `${(item.value / maxVal) * 100}%`,
                  background: item.color,
                  color: item.color,
                }}
              >
                <span className="pv-bar-value">
                  {d.valuePrefix ?? ''}
                  {item.value.toFixed(d.valueDigits ?? 2)}
                  {d.valueSuffix ?? ''}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
